// Shared type scale for the Firmwide Summary page: one section-title style, one caption style,
// neutral slate for chrome so colour is reserved for status and P&L / exposure meaning.
export const sectionTitleSx = {
  fontSize: '13px',
  fontWeight: 700,
  color: '#334155',
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
  lineHeight: 1.4,
};

export const sectionCaptionSx = {
  fontSize: '12px',
  color: '#64748b',
  lineHeight: 1.4,
};

export const surfaceSx = {
  backgroundColor: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '6px',
  boxShadow: 'none',
};

export const numeric = { fontVariantNumeric: 'tabular-nums' };
